export default {
      id: "luaeditor-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#luaeditor",
      toString: function () {
        return this.url;
      }
    }